import type {KeyTextField} from '@prismicio/client'
import {ButtonV2} from 'src/common/ButtonV2'
import {sanitizeHtml} from 'src/common/helpers/sanitizeHtml'

export const Welcome = ({
  title,
  subtext,
  disclaimer,
  startLabel,
  onContinue,
  pageUid,
}: {
  onContinue: () => void
  title: KeyTextField
  subtext: KeyTextField
  startLabel: KeyTextField
  disclaimer: KeyTextField
  pageUid: string
}) => (
  <div className="flex flex-col items-center justify-center gap-8">
    <div className="flex flex-col gap-3">
      <h1 className="text-h3 font-bold text-moss-black" dangerouslySetInnerHTML={{__html: sanitizeHtml(title || '')}} />
      <p className="text-body text-grey-300">{subtext}</p>
    </div>
    <ButtonV2
      variant="primary"
      onClick={onContinue}
      trackingData={{
        mktgId: 'start-quiz',
        location: 'survey-section',
        pageName: pageUid,
      }}
    >
      {startLabel}
    </ButtonV2>
    <p className="text-body-s italic text-grey-450">{disclaimer}</p>
  </div>
)
